import { render, staticRenderFns } from "./FaturamentoEvolucaoSupervisorVendas3PrecoMedio.vue?vue&type=template&id=0168856b&scoped=true&"
import script from "./FaturamentoEvolucaoSupervisorVendas3PrecoMedio.vue?vue&type=script&lang=js&"
export * from "./FaturamentoEvolucaoSupervisorVendas3PrecoMedio.vue?vue&type=script&lang=js&"
import style0 from "./FaturamentoEvolucaoSupervisorVendas3PrecoMedio.vue?vue&type=style&index=0&id=0168856b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0168856b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VContainer,VIcon})
